import React, { useEffect, useState, Suspense, lazy, Component } from 'react';
import { Hero } from './components/Hero';
import { useMetaPixel } from './components/useMetaPixel';
const BelowFold = lazy(() => import('./components/BelowFold').then(({
  BelowFold: Component
}) => ({
  default: Component
})));
export function App() {
  const [isBelowFoldReady, setIsBelowFoldReady] = useState(false);
  const [shouldScrollToPurchase, setShouldScrollToPurchase] = useState(false);
  useMetaPixel();
  useEffect(() => {
    let revealed = false;
    const revealBelowFold = () => {
      if (revealed) return;
      revealed = true;
      setIsBelowFoldReady(true);
    };
    const revealOnScroll = () => {
      if (window.scrollY > 24) revealBelowFold();
    };
    // Keep initial mobile bandwidth and rendering focused on the hero.
    // The full landing mounts as soon as visitors make a real scroll.
    window.addEventListener('scroll', revealOnScroll, {
      passive: true
    });
    const fallbackTimerId = window.setTimeout(revealBelowFold, 6000);
    return () => {
      window.removeEventListener('scroll', revealOnScroll);
      window.clearTimeout(fallbackTimerId);
    };
  }, []);
  useEffect(() => {
    if (!isBelowFoldReady || !shouldScrollToPurchase) return;
    let frameId = 0;
    let attempts = 0;
    const scrollWhenReady = () => {
      const purchaseSection = document.getElementById('planes');
      if (purchaseSection) {
        purchaseSection.scrollIntoView({
          behavior: 'smooth'
        });
        setShouldScrollToPurchase(false);
        return;
      }
      if (attempts < 30) {
        attempts += 1;
        frameId = requestAnimationFrame(scrollWhenReady);
      }
    };
    frameId = requestAnimationFrame(scrollWhenReady);
    return () => cancelAnimationFrame(frameId);
  }, [isBelowFoldReady, shouldScrollToPurchase]);
  const handlePurchaseRequest = () => {
    setShouldScrollToPurchase(true);
    setIsBelowFoldReady(true);
  };
  return <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-brand-500/30" data-id="element-0" data-mp="sssskuh76od1">
      <main data-id="element-1" data-mp="34x29ica5b3w">
        <Hero onPurchaseRequest={handlePurchaseRequest} data-id="element-2" data-mp="38kxqn1ac7l9" />
        {isBelowFoldReady && <Suspense fallback={null} data-id="element-3" data-mp="3ucjdpx58qhvb">
            <BelowFold data-id="element-4" data-mp="d4e75xjpjkyt" />
          </Suspense>}
      </main>
    </div>;
}